import React, {Component} from "react";
import Messenger from "../../messenger";
import writeMessageToApolloCache from "../../functions/writeMessageToApolloCache";
import {ErrorReportingContext} from "../../../General/components/ErrorReporting/ErrorReportingProvider";

function withMessageListener(WrappedComponent) {
    return class withMessageListenerContainer extends Component {
        static contextType = ErrorReportingContext;
        listenForMessages = (channel) => {
            Messenger.listenMessage(channel, (message) => {
                try {
                    // using try because this chat group may not be in the store yet
                    writeMessageToApolloCache(message, this.props.client, {
                        limit: this.props.limit,
                    });
                } catch (e) {
                    if (this.context && this.context.reportError) this.context.reportError(e);
                }
            });
        };

        render = () => (
            <WrappedComponent listenForMessages={this.listenForMessages} {...this.props} />
        );
    };
}

export default withMessageListener;
